import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function AuthGate({ children }) {
    const [checking, setChecking] = useState(true);
    const [session, setSession] = useState(null);
    const location = useLocation();

    useEffect(() => {
        let alive = true;

        const init = async () => {
            const { data, error } = await supabase.auth.getSession();

            // If the stored refresh token is invalid, Supabase can throw / log errors.
            // Clear local session so we stop retrying refresh and just show login.
            if (error) {
                console.warn("AuthGate getSession error:", error.message);
                await supabase.auth.signOut({ scope: "local" });
            }

            if (!alive) return;
            setSession(data?.session ?? null);
            setChecking(false);
        };

        init();

        const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => {
            setSession(s ?? null);
        });

        return () => {
            alive = false;
            sub.subscription.unsubscribe();
        };
    }, []);

    if (checking) return <div className="page-center">Loading...</div>;

    if (!session) {
        return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search || ""}` }} />;
    }

    return children;
}
